interface InteractionSeoDrug {
  productName: string;
  commonName?: string | null;
}

function normalizeValue(value?: string | null) {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}

export function getInteractionTopicHeading(drugs: InteractionSeoDrug[]) {
  const names = drugs
    .map((drug) => normalizeValue(drug.productName))
    .filter((name): name is string => name !== null);

  return `${names.join(' + ')} - interakcje leków`;
}

export function getDrugHeadingLabel(drug: InteractionSeoDrug) {
  const productName = normalizeValue(drug.productName) ?? '';
  const commonName = normalizeValue(drug.commonName);

  return commonName ? `${productName} (${commonName})` : productName;
}

export function getInteractionPairHeading(
  drugs: [InteractionSeoDrug, InteractionSeoDrug],
) {
  return `${getDrugHeadingLabel(drugs[0])} + ${getDrugHeadingLabel(drugs[1])}`;
}
